import { useEffect, useContext } from 'react';
import appInsights from '../components/shared/appInsights';
import { UserContext } from '../components/shared/useUser';
import { podClient } from '../app/services/api/podClient';
import { alseaLACFranchises } from '../enums/FranchiseNames';
import useLogError from './useLogError';

const usePageTimeTracker = (componentName: string) => {
  const { selectedStore, user } = useContext(UserContext);
  const { logError } = useLogError();

  useEffect(() => {
    const startTimestamp = Date.now();

    const trackPageTime = async () => {
      try{
        if (selectedStore?.storeNumber && user?.username) {
          const isAlseaLAC = alseaLACFranchises.includes(selectedStore.franchiseName ?? '');
          const isPodEnabled = isAlseaLAC
            ? false
            : (await podClient.getStoreConfiguration(
              `${selectedStore.storeNumber}`,
              selectedStore.storeNumber,
            )).isPodEnabled;

          const endTimestamp = Date.now();

          appInsights.trackEvent({
            name: 'PageTimeTracking',
            properties: {
              component: componentName,
              username: user.username,
              startTimestamp: new Date(startTimestamp).toISOString(),
              endTimestamp: new Date(endTimestamp).toISOString(),
              duration: endTimestamp - startTimestamp,
              storeNumber: selectedStore.storeNumber,
              isPodEnabled,
            },
          });
        }
      }catch(err){   
        logError(`Time tracking for ${componentName} failed.`); 
      }
    };

    return () => {
      trackPageTime();
    };
  }, [selectedStore?.storeNumber, user?.username, componentName]);
};

export default usePageTimeTracker;